import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';

import { concatWithDot } from 'helpers/string';

import { KEY_ASSUMPTIONS_NAMES, prefix } from '../utils/form';

export const SalesAssumptions: FC<{ disabled: boolean }> = ({ disabled }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.expectedRevenueVolume')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.EXPECTED_REVENUE_VOLUME)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.EXPECTED_REVENUE_VOLUME)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.EXPECTED_REVENUE_VOLUME)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.increaseFactors')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.INCREASE_FACTORS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.INCREASE_FACTORS)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.INCREASE_FACTORS)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.changeInPrices')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.CHANGE_IN_PRICES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.CHANGE_IN_PRICES)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.CHANGE_IN_PRICES)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.seasonalityAndEconomicCyclesAffection')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.SEASONALITY_AND_ECONOMIC_CYCLES_AFFECTION)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.SEASONALITY_AND_ECONOMIC_CYCLES_AFFECTION)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.SEASONALITY_AND_ECONOMIC_CYCLES_AFFECTION)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
    </>
  );
};
